const roundNumber = (number: number | string) => Math.round(Number(number) * 100) / 100;

export default roundNumber;
